import { render, staticRenderFns } from "./ViewContactsTypes.vue?vue&type=template&id=538ccfe5&scoped=true"
import script from "./ViewContactsTypes.vue?vue&type=script&lang=js"
export * from "./ViewContactsTypes.vue?vue&type=script&lang=js"
import style0 from "./ViewContactsTypes.vue?vue&type=style&index=0&id=538ccfe5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ccfe5",
  null
  
)

export default component.exports